export default class BlocksAccordion {
  constructor(callback) {
    this.accordions = $(".js-accordion");
    this.callback = callback;
  }

  init() {
    Array.from(this.accordions)?.forEach(accordion => {
      let open = false;

      $(".js-accordion-header", accordion)?.on("click", (e) => {
        $(accordion).toggleClass("is-open");

        !open
          ? $(".js-accordion-body", accordion)?.slideDown({
            complete: () => {
              this.callback?.call(null, { target: accordion, open: open })
            }
          })
          : $(".js-accordion-body", accordion)?.slideUp({
            complete: () => {
              this.callback?.call(null, { target: accordion, open: open })
            }
          });

        open = !open;
      });
    });
  }
}